import requests from "./httpService";

const CrmLeadsServices = {
  getLeads(companyId, params = {}) {
    const queryParams = new URLSearchParams({
      company_id: companyId,
      ...params
    }).toString();
    return requests.get(`/crm-leads/all?${queryParams}`);
  },
  getInitialData(companyId) {
    return requests.get(`/crm-leads/initial-data?company_id=${companyId}`);
  },
  getLead(companyId, leadId) {
    return requests.get(`/crm-leads/${leadId}?company_id=${companyId}`);
  },
  createLead(body) {
    return requests.post(`/crm-leads/create`, body);
  },
  updateLead(id, body) {
    return requests.post(`/crm-leads/update/${id}`, body);
  },
  deleteLead(id) {
    return requests.delete(`/crm-leads/delete/${id}`);
  },
  lookupCustomer(companyId, phone) {
    return requests.get(`/crm-leads/lookup-customer?company_id=${companyId}&phone=${phone}`);
  },
  createNote(body) {
    return requests.post(`/crm-leads/create-note`, body);
  },
  updateNote(id, body) {
    return requests.post(`/crm-leads/update-note/${id}`, body);
  },
  deleteNote(id, companyId) {
    return requests.post(`/crm-leads/delete-note/${id}`, { company_id: companyId });
  },
  updateNoteReaction(id, body) {
    return requests.post(`/crm-leads/update-note-reaction/${id}`, body);
  },
  getDashboard(companyId, startDate, endDate) {
    const params = new URLSearchParams({ company_id: companyId });
    if (startDate) params.append("start_date", startDate);
    if (endDate)   params.append("end_date", endDate);
    return requests.get(`/crm-leads/dashboard?${params.toString()}`);
  }
};

export default CrmLeadsServices;
